import { GetApiRequest } from '@/plugins/api/base'

export class GetLineEventById extends GetApiRequest {
  constructor(context, data) {
    const culture = context.i18n.locale.value

    const url = `/api/line/${culture}/event/${data.eventId}`
    super(context, url)
  }
}
